import { dew as _stringsDew } from "./strings";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.pdfDocEncodingDecode = void 0;

  var strings_1 = _stringsDew(); // Mapping from PDFDocEncoding to Unicode code point


  var pdfDocEncodingToUnicode = new Uint16Array(256); // Initialize the code points which are the same

  for (var idx = 0; idx < 256; idx++) {
    pdfDocEncodingToUnicode[idx] = idx;
  } // Set differences (see "Table D.2 – PDFDocEncoding Character Set" of the PDF spec)


  pdfDocEncodingToUnicode[22] = strings_1.toCharCode("\x17"); // SYNCRONOUS IDLE

  pdfDocEncodingToUnicode[24] = strings_1.toCharCode("\u02D8"); // BREVE

  pdfDocEncodingToUnicode[25] = strings_1.toCharCode("\u02C7"); // CARON

  pdfDocEncodingToUnicode[26] = strings_1.toCharCode("\u02C6"); // MODIFIER LETTER CIRCUMFLEX ACCENT

  pdfDocEncodingToUnicode[27] = strings_1.toCharCode("\u02D9"); // DOT ABOVE

  pdfDocEncodingToUnicode[28] = strings_1.toCharCode("\u02DD"); // DOUBLE ACUTE ACCENT

  pdfDocEncodingToUnicode[29] = strings_1.toCharCode("\u02DB"); // OGONEK

  pdfDocEncodingToUnicode[30] = strings_1.toCharCode("\u02DA"); // RING ABOVE

  pdfDocEncodingToUnicode[31] = strings_1.toCharCode("\u02DC"); // SMALL TILDE

  pdfDocEncodingToUnicode[127] = strings_1.toCharCode("\uFFFD"); // REPLACEMENT CHARACTER (box with questionmark)

  pdfDocEncodingToUnicode[128] = strings_1.toCharCode("\u2022"); // BULLET

  pdfDocEncodingToUnicode[129] = strings_1.toCharCode("\u2020"); // DAGGER

  pdfDocEncodingToUnicode[130] = strings_1.toCharCode("\u2021"); // DOUBLE DAGGER

  pdfDocEncodingToUnicode[131] = strings_1.toCharCode("\u2026"); // HORIZONTAL ELLIPSIS

  pdfDocEncodingToUnicode[132] = strings_1.toCharCode("\u2014"); // EM DASH

  pdfDocEncodingToUnicode[133] = strings_1.toCharCode("\u2013"); // EN DASH

  pdfDocEncodingToUnicode[134] = strings_1.toCharCode("\u0192"); // LATIN SMALL LETTER SCRIPT F

  pdfDocEncodingToUnicode[135] = strings_1.toCharCode("\u2044"); // FRACTION SLASH (solidus)

  pdfDocEncodingToUnicode[136] = strings_1.toCharCode("\u2039"); // SINGLE LEFT-POINTING ANGLE QUOTATION MARK

  pdfDocEncodingToUnicode[137] = strings_1.toCharCode("\u203A"); // SINGLE RIGHT-POINTING ANGLE QUOTATION MARK

  pdfDocEncodingToUnicode[138] = strings_1.toCharCode("\u2212"); // MINUS SIGN

  pdfDocEncodingToUnicode[139] = strings_1.toCharCode("\u2030"); // PER MILLE SIGN

  pdfDocEncodingToUnicode[140] = strings_1.toCharCode("\u201E"); // DOUBLE LOW-9 QUOTATION MARK (quotedblbase)

  pdfDocEncodingToUnicode[141] = strings_1.toCharCode("\u201C"); // LEFT DOUBLE QUOTATION MARK (quotedblleft)

  pdfDocEncodingToUnicode[142] = strings_1.toCharCode("\u201D"); // RIGHT DOUBLE QUOTATION MARK (quotedblright)

  pdfDocEncodingToUnicode[143] = strings_1.toCharCode("\u2018"); // LEFT SINGLE QUOTATION MARK (quoteleft)

  pdfDocEncodingToUnicode[144] = strings_1.toCharCode("\u2019"); // RIGHT SINGLE QUOTATION MARK (quoteright)

  pdfDocEncodingToUnicode[145] = strings_1.toCharCode("\u201A"); // SINGLE LOW-9 QUOTATION MARK (quotesinglbase)

  pdfDocEncodingToUnicode[146] = strings_1.toCharCode("\u2122"); // TRADE MARK SIGN

  pdfDocEncodingToUnicode[147] = strings_1.toCharCode("\uFB01"); // LATIN SMALL LIGATURE FI

  pdfDocEncodingToUnicode[148] = strings_1.toCharCode("\uFB02"); // LATIN SMALL LIGATURE FL

  pdfDocEncodingToUnicode[149] = strings_1.toCharCode("\u0141"); // LATIN CAPITAL LETTER L WITH STROKE

  pdfDocEncodingToUnicode[150] = strings_1.toCharCode("\u0152"); // LATIN CAPITAL LIGATURE OE

  pdfDocEncodingToUnicode[151] = strings_1.toCharCode("\u0160"); // LATIN CAPITAL LETTER S WITH CARON

  pdfDocEncodingToUnicode[152] = strings_1.toCharCode("\u0178"); // LATIN CAPITAL LETTER Y WITH DIAERESIS

  pdfDocEncodingToUnicode[153] = strings_1.toCharCode("\u017D"); // LATIN CAPITAL LETTER Z WITH CARON

  pdfDocEncodingToUnicode[154] = strings_1.toCharCode("\u0131"); // LATIN SMALL LETTER DOTLESS I

  pdfDocEncodingToUnicode[155] = strings_1.toCharCode("\u0142"); // LATIN SMALL LETTER L WITH STROKE

  pdfDocEncodingToUnicode[156] = strings_1.toCharCode("\u0153"); // LATIN SMALL LIGATURE OE

  pdfDocEncodingToUnicode[157] = strings_1.toCharCode("\u0161"); // LATIN SMALL LETTER S WITH CARON

  pdfDocEncodingToUnicode[158] = strings_1.toCharCode("\u017E"); // LATIN SMALL LETTER Z WITH CARON

  pdfDocEncodingToUnicode[159] = strings_1.toCharCode("\uFFFD"); // REPLACEMENT CHARACTER (box with questionmark)

  pdfDocEncodingToUnicode[160] = strings_1.toCharCode("\u20AC"); // EURO SIGN

  pdfDocEncodingToUnicode[173] = strings_1.toCharCode("\uFFFD"); // REPLACEMENT CHARACTER (box with questionmark)

  /**
   * Decode a byte array into a string using PDFDocEncoding.
   *
   * @param bytes a byte array (decimal representation) containing a string
   *              encoded with PDFDocEncoding.
   */

  exports.pdfDocEncodingDecode = function (bytes) {
    var codePoints = new Array(bytes.length);

    for (var idx = 0, len = bytes.length; idx < len; idx++) {
      codePoints[idx] = pdfDocEncodingToUnicode[bytes[idx]];
    }

    return String.fromCodePoint.apply(String, codePoints);
  }; //# sourceMappingURL=pdfDocEncoding.js.map


  return exports;
}